import React from "react";
import Navbar from "../navbar/Navbar";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import "./videofile.css";



export default function ThirdSemVideo() {
  return (
    <div>
      <Navbar />
      <Link id='back' to="/">
                <Button style={{ margin: '10px',marginTop:'80px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
    
      <h1 id ='desc' style={{ textAlign: "center" }}>Third sem CSE/ISE Video Class</h1>
      <Divider/>

     <h2>Subject 1</h2>
     <div className="scrollmenu" style={{ marginTop: "10px" }}>
    
        </div>
        <Divider/>

    </div>
  );
}
